export const getEnvSetting = (setting, mandatory=true) => {
    const value = process.env[setting]  // eslint-disable-line
    if (value === undefined && mandatory) {
        throw new Error(`Missing ${setting} in .env file`)
    }
    return value
}


/** WEBPACK FOOTER **
 ** ./src/utils/env.js
 **/